import { render, staticRenderFns } from "./UsersExpansion.vue?vue&type=template&id=da6e45e4"
import script from "./UsersExpansion.vue?vue&type=script&lang=js"
export * from "./UsersExpansion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports